exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.highlight {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n.doc-tag {\n  position: absolute;\n  background-color: rgba(255, 198, 10, 0.5);\n  pointer-events: none;\n  z-index: 1;\n}\n.tag-active {\n  background-color: rgba(245, 74, 69, 0.5);\n}\n", ""]);

// exports
